import { Helmet } from "react-helmet";
import { useAuth } from "../Auth/AuthProvider";
import { useWindowWidth } from "../Hooks/useWindowWidth";
import { useTranslation } from "react-i18next";

const routes = ["Check In", "Check Out"]
export const PageLayout = ({ title, header, children }) => {
  const { isSideOpen } = useAuth();
  const width = useWindowWidth();
  const {t} = useTranslation();
  const isTablet = (width <= 1300 && width > 500)
  return (
    <div className="global-cont">
      <Helmet>
        <title>Forward | {title}</title>
      </Helmet>
      <div
        className={`page-overview ${
          isSideOpen && isTablet ? "shift" : ""
        }`}
      >
        <div className={`${!routes.includes(title) ? "cont-wrapper" : "full-width"}`}>
          {header && (
            <div className="overview-header">
              <h1 className="global-h1 black">{t(`page-headers.${header}`)}</h1>
            </div>
          )}
          {children}</div>
      </div>
    </div>
  );
};
